// in this file we will put all variables that are const and should be re-used across the project.
// goal of having this file is to allow us easily to configure project simply changing some of the data that are here in configuration file, like const with fetch.
// using uppercase for variable is common thing for variables that are stored in config file.
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const API_KEY = '411edc36-7059-4ecf-981e-da8402157f92';
export const MODAL_CLOSE_SEC = 2.5;
